import { render } from "./WalletCard.vue?vue&type=template&id=bc570f90&scoped=true"
import script from "./WalletCard.vue?vue&type=script&lang=js"
export * from "./WalletCard.vue?vue&type=script&lang=js"

import "./WalletCard.vue?vue&type=style&index=0&id=bc570f90&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc570f90"]])

export default __exports__